'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defaultDiscountCodeState = {
  fetchStatus: 'idle',
  discountCode: '',
  verificationFieldQuestion: ''
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    error: false,
    policyId: undefined,
    loginId: undefined,
    snapshots: {},
    summary: {
      renewalStage1: true,
      renewalStage2: true,
      renewalStage3: true,
      renewalStage4: true
    },
    validated: {
      renewalStage1: false,
      renewalStage2: false,
      renewalStage3: false,
      renewalStage4: false
    },
    discountCode: defaultDiscountCodeState
  };
  var action = arguments[1];
  if (!state.discountCode) {
    state = Object.assign({}, state, {
      discountCode: defaultDiscountCodeState
    });
  }
  switch (action.type) {
    case _constants.actionTypes.SUBMIT_APPLICATION + '_' + _reduxPromiseMiddleware.REJECTED:
      return Object.assign({}, state, {
        error: true
      });
    case _constants.actionTypes.SUBMIT_APPLICATION:
      return Object.assign({}, state, {
        error: false,
        policyId: action.policyId,
        loginId: action.loginId
      });
    case _constants.actionTypes.SNAPSHOT:
      return Object.assign({}, state, {
        snapshots: Object.assign({}, state.snapshots, _defineProperty({}, action.id, action.form))
      });
    case _constants.actionTypes.SHOW_SUMMARY:
      return Object.assign({}, state, {
        summary: Object.assign({}, state.summary, _defineProperty({}, action.id, true))
      });
    case _constants.actionTypes.SHOW_FORM:
      return Object.assign({}, state, {
        summary: Object.assign({}, state.summary, _defineProperty({}, action.id, false))
      });
    case _constants.actionTypes.SET_VALIDATED:
      return Object.assign({}, state, {
        validated: Object.assign({}, state.validated, _defineProperty({}, action.id, true))
      });
    case _constants.actionTypes.SET_DISCOUNT_CODE:
      return Object.assign({}, state, {
        discountCode: Object.assign({}, state.discountCode, action.value)
      });
    case '@@INIT':
      return Object.assign({}, state, {
        discountCode: Object.assign({}, state.discountCode, {
          fetchStatus: state.discountCode.fetchStatus === 'fetching' ? 'idle' : state.discountCode.fetchStatus
        })
      });
    default:
      return state;
  }
};